



























































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import UnitRuangPicker from "@/components/common/UnitRuangPicker.vue";
import SerahTerimaDarahDialog from "@/components/bank-darah/SerahTerimaDarahDialog.vue";
import OrderBankDarahSvc from "@/services/OrderBankDarah";
import OrderBankDarahStore from "@/store/modules/OrderBankDarahStore";
import { appModule } from "@/store/modules/app";
import {
  HasilStatus,
  OpsiNilai,
  OrderBankDarahRow,
  STATUS_WARNA
} from "@/types/order_bank_darah";
import { composeDate, toDateString } from "@/utils/asesmenIntensifDateTime";
import { cocokCariPasien } from "@/utils/cariPasienBankDarah";
import { bukaPemeriksaanBankDarah } from "@/utils/bukaPemeriksaanBankDarah";

type BarisOrder = OrderBankDarahRow & { key: string };

interface TabOrder {
  key: string;
  label: string;
  status: string[];
  kosong: string;
}

const TABS: TabOrder[] = [
  { key: "masuk", label: "Order Masuk", status: ["dikirim"], kosong: "Tidak ada order masuk." },
  {
    key: "diterima",
    label: "Diterima / Menunggu Sampel",
    status: ["diterima", "menunggu_sampel"],
    kosong: "Tidak ada order yang menunggu serah terima."
  },
  { key: "diproses", label: "Diproses", status: ["dikerjakan"], kosong: "Tidak ada order yang sedang diproses." },
  { key: "selesai", label: "Selesai", status: ["selesai"], kosong: "Tidak ada order selesai pada periode ini." },
  { key: "batal", label: "Dibatalkan", status: ["dibatalkan"], kosong: "Tidak ada order dibatalkan pada periode ini." }
];

const STATUS_BERJALAN = ["dikirim", "diterima", "menunggu_sampel", "dikerjakan"];

@Component({ components: { VCDateTimePicker, UnitRuangPicker, SerahTerimaDarahDialog } })
export default class CardDaftarOrderBankDarah extends Vue {
  readonly tabs = TABS;

  tab = 0;
  loading = false;
  showFilter = false;
  search: string | null = null;
  rows: BarisOrder[] = [];
  jenisItems: OpsiNilai[] = [];

  filter: {
    tgl_start: string;
    tgl_end: string;
    jenis: string[];
    unit_id: string | null;
  } = {
    tgl_start: moment().subtract(30, "days").format("YYYY-MM-DD"),
    tgl_end: moment().format("YYYY-MM-DD"),
    jenis: [],
    unit_id: null
  };

  pilih: BarisOrder | null = null;
  prosesKey: string | null = null;
  dialogSerahTerima = false;
  dialogBatal = false;
  alasanBatal = "";

  readonly headers = [
    { text: "No Order / Tgl", value: "nomor", width: "120px" },
    { text: "Jenis Permintaan", value: "jenis_label" },
    { text: "Pasien", value: "pasien", sortable: false },
    { text: "Unit / Pemohon", value: "unit", sortable: false },
    { text: "Jenis Order", value: "jenis_order", sortable: false, width: "80px" },
    { text: "Status", value: "status", sortable: false, width: "110px" },
    { text: "Aksi", value: "aksi", sortable: false, align: "end", width: "110px" }
  ];

  get tabAktif(): TabOrder {
    return TABS[this.tab] || TABS[0];
  }

  get rowsCari(): BarisOrder[] {
    return this.rows.filter(r =>
      cocokCariPasien(this.search, [r.pasien_rm, r.pasien_nama, r.register_id, r.nomor])
    );
  }

  get rowsTab(): BarisOrder[] {
    const status = this.tabAktif.status;
    return this.rowsCari.filter(r => status.includes(r.status));
  }

  get tglStartDate(): Date | null {
    return composeDate(this.filter.tgl_start);
  }
  set tglStartDate(val: Date | null) {
    this.filter.tgl_start = toDateString(val) || this.filter.tgl_start;
  }

  get tglEndDate(): Date | null {
    return composeDate(this.filter.tgl_end);
  }
  set tglEndDate(val: Date | null) {
    this.filter.tgl_end = toDateString(val) || this.filter.tgl_end;
  }

  mounted() {
    this.$root.$on("order-bank-darah:muat-ulang", this.muatDariNotifikasi);
    this.muat();
  }

  beforeDestroy() {
    this.$root.$off("order-bank-darah:muat-ulang", this.muatDariNotifikasi);
  }

  muatDariNotifikasi() {
    this.tab = 0;
    this.muat();
  }

  jumlah(t: TabOrder, pakaiCari = true): number {
    const sumber = pakaiCari ? this.rowsCari : this.rows;
    return sumber.filter(r => t.status.includes(r.status)).length;
  }

  async muat(senyap = false) {
    if (!senyap) this.loading = true;
    const dasar = { jenis: this.filter.jenis, unit_id: this.filter.unit_id };

    const periode = { tgl_start: this.filter.tgl_start, tgl_end: this.filter.tgl_end };

    try {
      const [berjalan, selesai, batal] = await Promise.all([
        OrderBankDarahSvc.list({ ...dasar, tgl_start: null, tgl_end: null, status: STATUS_BERJALAN }),
        OrderBankDarahSvc.list({ ...dasar, ...periode, tgl_kolom: "selesai_at", status: ["selesai"] }),
        OrderBankDarahSvc.list({ ...dasar, ...periode, tgl_kolom: "dibatalkan_at", status: ["dibatalkan"] })
      ]);
      this.jenisItems = berjalan.jenis_options;
      this.rows = [...berjalan.rows, ...selesai.rows, ...batal.rows].map(r => ({
        ...r,
        key: `${r.sumber}:${r.id}`
      }));
    } catch {
      return;
    } finally {
      this.loading = false;
    }

    OrderBankDarahStore.fetchCount();
  }

  setelahBerubah() {
    this.muat(true);
    this.$emit("changed");
  }

  warnaStatus(status: string): string {
    return STATUS_WARNA[status] || "blue-grey";
  }

  warnaHasil(status: HasilStatus): string {
    return { belum: "grey lighten-1", draft: "orange", final: "green" }[status];
  }

  labelHasil(status: HasilStatus): string {
    return {
      belum: "belum ada",
      draft: "draft",
      final: "terverifikasi"
    }[status];
  }

  waktu(val: string | null): string {
    return val ? moment(val, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY HH:mm") : "-";
  }

  bisaSerahTerima(item: BarisOrder): boolean {
    return ["diterima", "menunggu_sampel", "dikerjakan", "selesai"].includes(item.status);
  }

  tampilBatal(item: BarisOrder): boolean {
    return STATUS_BERJALAN.includes(item.status) || item.status === "selesai";
  }

  async terima(item: BarisOrder) {
    this.prosesKey = item.key;
    try {
      const res = await OrderBankDarahSvc.terima(item.sumber, item.id);
      appModule.sendSuccessNotice(res.message);
      await this.muat(true);
      this.$emit("changed");
      this.bukaSerahTerima({ ...item, status: "diterima" });
    } catch {
      return;
    } finally {
      this.prosesKey = null;
    }
  }

  bukaSerahTerima(item: BarisOrder) {
    this.pilih = item;
    this.dialogSerahTerima = true;
  }

  bukaBatal(item: BarisOrder) {
    this.pilih = item;
    this.alasanBatal = "";
    this.dialogBatal = true;
  }

  async batal() {
    if (!this.pilih || !this.alasanBatal.trim()) return;

    this.prosesKey = this.pilih.key;
    try {
      const res = await OrderBankDarahSvc.batal(this.pilih.sumber, this.pilih.id, this.alasanBatal.trim());
      appModule.sendSuccessNotice(res.message);
      this.dialogBatal = false;
      this.setelahBerubah();
    } catch {
      return;
    } finally {
      this.prosesKey = null;
    }
  }

  bukaPemeriksaan(registerId: string) {
    bukaPemeriksaanBankDarah(this.$router, registerId);
  }

  lihatHasil(item: BarisOrder) {
    this.$router.push({
      name: "bank-darah-hasil",
      query: {
        rm: item.pasien_rm,
        register: String(item.register_id),
        nama: item.pasien_nama || "",
        jenis: item.jenis
      }
    });
  }
}
